import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-review-report-modal',
  templateUrl: './review-report-modal.component.html',
  styleUrls: ['./review-report-modal.component.css']
})
export class ReviewReportModalComponent implements OnInit {

  // Set by BsModalService from initialState.
  assessmentInfo: any;

  reportUrl: SafeResourceUrl;
  embedUrl: SafeResourceUrl;

  constructor(
    private bsModalRef: BsModalRef,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    const endpoint = 'api/candidate/candidatepdfreport?testinvitationid='
      + encodeURIComponent(this.assessmentInfo.testInvitationId) + '&sectional=false';
    this.reportUrl = this.sanitizer.bypassSecurityTrustResourceUrl(endpoint);
    this.embedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(endpoint + '#view=fitH');
  }

  closeModal() {
    this.bsModalRef.hide();
  }

}
